import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/general/confirm-dialog/confirm-dialog.component';
import { InputrelatieComponent } from 'src/app/shared/components/inputrelatie/inputrelatie.component';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { OfferteService } from 'src/app/shared/dataservices/offerte.service';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { OfferteInkoop } from 'src/app/shared/model/offerte';

@Component({
  selector: 'app-offerte-edit-line',
  templateUrl: './offerte-edit-line.component.html',
  styleUrls: ['./offerte-edit-line.component.less']
})
export class OfferteEditLineComponent implements OnInit {

  @Input() offerteline : OfferteInkoop;
  @Output() newLine =  new EventEmitter<OfferteInkoop>();
  @Output() deleted =  new EventEmitter<number>();
  relaties : any;
  statusList: any;

  @ViewChild(InputrelatieComponent)
  private relatieComponent!: InputrelatieComponent;


  constructor(private relatiesService: RelatiesService,
    private objectenService: ObjectenService,
    private offerteService: OfferteService,
    private dialog: MatDialog,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.relatiesService.getActiveRelatieList().subscribe(data => {
      this.relaties = data;
    })

    this.objectenService.getStatusList().subscribe(data => {
      this.statusList = data;
    })

  }


  save() {
      if (this.offerteline.ID == 0) {
          this.offerteService.postOfferteInkoop(this.offerteline).subscribe(data => {
            if (!data.id) return; //this is an error state
            let newOfferteLine = new OfferteInkoop();
            newOfferteLine.ID = data.id;
            newOfferteLine.BedrijfNummer = this.offerteline.BedrijfNummer;
            newOfferteLine.InvoerDatum = this.offerteline.InvoerDatum;
            newOfferteLine.KostenEuro = this.offerteline.KostenEuro
            newOfferteLine.MutatieDatum = this.offerteline.MutatieDatum
            newOfferteLine.OfferteID = this.offerteline.OfferteID
            newOfferteLine.StatusCodeID = this.offerteline.StatusCodeID
            newOfferteLine.Toelichting = this.offerteline.Toelichting
            //clear the value of the relatieComponent.
            //HacK!!
            this.relatieComponent.reset();
            this.newLine.emit(newOfferteLine);
            this.toastr.success("", "Opgeslagen");
          })
      } else {
        this.offerteService.saveOfferteInkoop(this.offerteline.ID, this.offerteline).subscribe(data => {
          this.toastr.success("", "Opgeslagen");
        })

      }
  }

  //make sure any type of numbers will be accepted.
  sanitizeNumber(event: any) {
    try {
      if (event.target && event.target.value) {
        let num : number = Number(event.target.value.replace(",","."));
        this.offerteline.KostenEuro = num;
      }
    } catch (e) {
      console.log(e)
    }
  }


  delete() {
    const message = `Weet je zeker dat je dit wilt doen?`;

    const dialogData = new ConfirmDialogModel("Bevestig verwijdering", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      const result = dialogResult;
      if (result) {
          this.offerteService.deleteOfferteInkoop(this.offerteline.ID).subscribe(() => {
            this.toastr.error("", "Verwijderd");
            this.deleted.emit(this.offerteline.ID)
          }
          );
        }
      });

  }

}
